var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIsNewBigEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 45,
    viewBox: "0 0 102 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.125 24V44.999L97.9975 25.924L69.125 24Z",
    fill: "url(#paint0_linear_3604_20272)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98 0H3V25.9988H98V0Z",
    fill: "#E22424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9141 16V7.41016H40.0801L44.5918 14.1543V7.41016H45.6816V16H44.5156L40.0039 9.25V16H38.9141ZM51.7227 13.9961L52.8125 14.1309C52.6406 14.7676 52.3223 15.2617 51.8574 15.6133C51.3926 15.9648 50.7988 16.1406 50.0762 16.1406C49.166 16.1406 48.4434 15.8613 47.9082 15.3027C47.377 14.7402 47.1113 13.9531 47.1113 12.9414C47.1113 11.8945 47.3809 11.082 47.9199 10.5039C48.459 9.92578 49.1582 9.63672 50.0176 9.63672C50.8496 9.63672 51.5293 9.91992 52.0566 10.4863C52.584 11.0527 52.8477 11.8496 52.8477 12.877C52.8477 12.9395 52.8457 13.0332 52.8418 13.1582H48.2012C48.2402 13.8418 48.4336 14.3652 48.7812 14.7285C49.1289 15.0918 49.5625 15.2734 50.082 15.2734C50.4688 15.2734 50.7988 15.1719 51.0723 14.9688C51.3457 14.7656 51.5625 14.4414 51.7227 13.9961ZM48.2598 12.291H51.7344C51.6875 11.7676 51.5547 11.375 51.3359 11.1133C51 10.707 50.5645 10.5039 50.0293 10.5039C49.5449 10.5039 49.1367 10.666 48.8047 10.9902C48.4766 11.3145 48.2949 11.748 48.2598 12.291ZM55.291 16L53.3867 9.77734H54.4766L55.4668 13.3691L55.8359 14.7051C55.8516 14.6387 55.959 14.2109 56.1582 13.4219L57.1484 9.77734H58.2324L59.1641 13.3867L59.4746 14.5762L59.832 13.375L60.8984 9.77734H61.9238L59.9785 16H58.8828L57.8926 12.2734L57.6523 11.2129L56.3926 16H55.291Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3604_20272",
    x1: 83.5607,
    y1: 47.7265,
    x2: 83.5607,
    y2: -0.447303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E22424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E02323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D92222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CD2020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BC1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A61A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#8B1616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#6A1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#450B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#1C0404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsNewBigEn);
export default __webpack_public_path__ + "static/media/is_new_big_en.5b19d9d98ffc33e762095aecb8e4da59.svg";
export { ForwardRef as ReactComponent };